import {
    EXPORT_REQUEST,
    EXPORT_SUCCESS,
    EXPORT_FAILURE,
} from '@/administration/import-export/actions/export.js';

const initialState = {
    byTargetId: {},
};

const setStatus = (state, targetId, status) => ({
    ...state,
    byTargetId: {
        ...state.byTargetId,
        [targetId]: status,
    },
});

const app = (state = initialState, action) => {
    const {type, payload} = action;

    switch (type) {
        case EXPORT_REQUEST:
            return setStatus(state, payload.targetId, {status: 'loading', error: null});
        case EXPORT_SUCCESS:
            return setStatus(state, payload.targetId, {status: 'success', error: null});
        case EXPORT_FAILURE:
            return setStatus(state, payload.targetId, {status: 'error', error: payload.error});
        default:
            return state;
    }
};

export default app;
